import gql from 'graphql-tag';
import { useSubscription } from '@apollo/react-hooks';

import { getAGGClient } from '@confluence/graphql';
import { getConfluenceContentAri } from '@confluence/content-types-utils';
import { useSessionData } from '@confluence/session-data';
import { getAnalyticsWebClient } from '@confluence/analytics-web-client';
import { getMonitoringClient } from '@confluence/monitoring';
import { Attribution } from '@confluence/error-boundary';

const subscription = gql`
	subscription ContentTypesTitleSubscription($id: ID!) {
		confluence_onContentModified(id: $id) {
			type
			id
			__typename
			_deltas
			contentTitleUpdated {
				contentTitle
				__typename
			}
		}
	}
`;

// exported for testing purposes only
export const onSubscriptionData = (
	response: any,
	onDataReceived: (data: string) => void,
	contentId: string,
	contentType: string,
) => {
	getAnalyticsWebClient().then((client) => {
		client.sendOperationalEvent({
			action: 'received',
			actionSubject: 'subscription.event',
			actionSubjectId: 'contentTitleUpdated',
			source: 'contentTypesTitleSubscription',
			attributes: {
				contentId,
				contentType,
			},
		});
	});

	const data = response?.subscriptionData?.data;
	const _deltas = data?.confluence_onContentModified?._deltas;
	if (!data || !Array.isArray(_deltas)) {
		return;
	}
	if (_deltas?.length === 0 || _deltas.indexOf('contentTitleUpdated') === -1) {
		return;
	}
	const { contentTitleUpdated } = data?.confluence_onContentModified;
	const title = contentTitleUpdated?.contentTitle;

	onDataReceived(title);
};
export const ContentTypesTitleSubscription = ({
	contentType,
	contentId,
	onDataReceived,
	skip = false,
}: {
	contentType: string;
	contentId: string;
	onDataReceived: (data: string) => void;
	skip?: boolean;
}) => {
	const { activationId, cloudId } = useSessionData();

	const ari = getConfluenceContentAri({
		siteId: cloudId,
		resourceType: contentType,
		activationId,
		resourceId: contentId,
	});

	const { error } = useSubscription(subscription, {
		variables: {
			id: ari,
		},
		onSubscriptionData(response) {
			onSubscriptionData(response, onDataReceived, contentId, contentType);
		},
		skip,
		client: getAGGClient(),
	});

	if (error) {
		const e = new Error(`Subscription Error - ContentTypesTitleSubscription: ${error}`);
		getMonitoringClient().submitError(e, {
			attribution: Attribution.PAGE_EXPERIENCES,
		});
	}
	return null;
};
